var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 18 17",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m186.029775 29.92578 6.86475-4.4256667-6.86475-4.4251zm10.845169 2.3724067c-.000563.0005666-.001125.0017-.00225.0022666h-15.746063c-.000562-.0005666-.001687-.0011333-.00225-.0022666v-13.5960334c.000563-.0005666.001125-.0017.00225-.0022666h15.746063c.000562.0005666.001687.0011333.00225.0022666zm0-14.7310667-15.749438-.0005667c-.61875 0-1.125.51-1.125 1.1333334l-.000562.0005666v13.6c0 .6233334.50625 1.1333334 1.125 1.1333334h15.75c.61875 0 1.125-.51 1.125-1.1333334v-13.6c0-.6233333-.50625-1.1333333-1.125-1.1333333z",
    fill: "#fff",
    fillRule: "evenodd",
    transform: "translate(-180 -17)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.7bbb3551a9fb7610887320edf23638d7.svg";
export { ForwardRef as ReactComponent };